const urls = {
  external: {
    announcements: 'https://support.binance.us/hc/en-us/categories/360003671074-Announcements',
    support: 'https://support.binance.us/hc/en-us',
    supportLogin: 'https://support.binance.us/hc/en-us',
    supportRequest: 'https://support.binance.us/hc/en-us/requests/new',
    faqUrl: 'https://www.binance.com/%locale/support/categories/360002072912-FAQs',
    aboutFee: 'https://support.binance.us/hc/en-us',
    notGetAccount: 'https://support.binance.us/hc/en-us',
    contactUs: 'https://support.binance.us/hc/en-us',
    securityTips: 'https://support.binance.us/hc/en-us',
    setEmailWhiteList: 'https://support.binance.us/hc/en-us',
    faq: 'https://support.binance.us/hc/en-us/categories/360002072912-FAQs',
    contactUs2: '/%locale/about',
    tutorials: 'https://academy.binance.com/en/articles/what-is-a-stop-limit-order?utm_source=binanceUS&utm_medium=snippet&utm_campaign=levelup',
    sasitus: 'https://support.binance.us/hc/en-us/articles/360046786914-States-That-Binance-US-Does-Not-Currently-Support',
  },
  wallet: {
    balances: '/%locale/usercenter/wallet/balances',
    deposit: '/%locale/usercenter/wallet/deposit/BTC',
    withdraw: '/%locale/usercenter/wallet/withdrawals/BTC',
    depositWithdrawHistory: '/%locale/usercenter/wallet/money-log',
    buySellHistory: '/%locale/usercenter/wallet/buy-sell-history',
    distributionHistory: '/%locale/usercenter/wallet/distribution-history',
  },
  user: {
    index: '/%locale/usercenter/dashboard/overview',
    addressVerify: '/%locale/usercenter/address/verify',
    security: '/%locale/usercenter/security',
    identity: '/userCenter/identity.html',
    orderHistory: '/%locale/usercenter/history/trade-order',
    openOrders: '/%locale/usercenter/open-order',
    tradeHistory: '/%locale/usercenter/user-trade',
    creditcard: '/%locale/buy-sell-crypto',
    deviceDetail:
      '/userCenter/userDeviceDetail.html?devicePk=%devicePrimaryKey&deviceName=%deviceName',
  },
  site: {
    about: '/%locale/about',
    termsOfUse: '/%locale/terms-of-use',
    privacyPolicy: '/%locale/privacy-policy',
    disclosures: '/%locale/disclosures',
    tradingRules: '/%locale/trading-rules',
    linkedWalletAddendum: '/%locale/prime-trust-linked-wallet-addendum',
    fees: '/%locale/fee/schedule',
    api: 'https://github.com/binance-us',
    applyToList: '/%locale/usercenter/coin-apply',
    tradeLimits: '/%locale/trade-limits',
    // applyToList: '/userCenter/coinApply.html',
    bnb: '/%locale/use-bnb',
    blog: 'https://support.binance.us/hc/en-us/categories/360003976494-Blog',
    downloadApp: '/%locale/downloadApp',
    login: '/%locale/login',
    register: '/%locale/register',
    resetPassword: '/%locale/forgotPassword',
    resetGoogleAuth: '/%locale/reset2fa/google',
    resetMobile: '/%locale/reset2fa/mobile',
    community: '/%locale/community',
    referral: '/%locale/referral-details',
    markets: '/%locale/markets',
    trade: '/%locale/trade/pro/BTC_USD',
  },
  media: {
    community: '/%locale/community',
    facebook: 'https://www.facebook.com/BinanceUS/',
    twitter: 'https://www.twitter.com/binanceus',
    linkedin: 'https://www.linkedin.com/company/binance-us',
    medium: 'https://medium.com/binance-us',
    telegram: 'https://t.me/BinanceUSAnnouncements',
    youtube: 'https://www.youtube.com/channel/UCOy0sepBMqnlzdaRr_Tlczw?view_as=subscriber',
    instagram: 'https://www.instagram.com/binance_us/',
  },
  errors: {
    error: '/%locale/error/%statusCode',
  },
  fee: {
    makerTakerUrl: 'https://support.binance.us/hc/en-us/articles/360047428773-What-Maker-and-Taker-Mean',
    moreDetails: 'https://support.binance.us/hc/en-us/articles/360046786894-Using-BNB-to-Pay-for-Fees',
  },
};

export default urls;
